<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="实名认证" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="handleCancel">
        <template #footer>
            <a-button key="back" @click="handleCancel">取消</a-button>
            <a-button key="submit" type="primary" :loading="state.loading" @click="onFormSubmit">提交认证</a-button>
        </template>
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="身份证" name="id_card_front" required :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 17 }">
                    <IdCardForm v-model:front="formState.id_card_front" v-model:back="formState.id_card_back"
                        @change="frChange" size="large"
                        :uploadPath="`public/uploads/manage/users/${dayjs().format('YYYYMM')}/`"></IdCardForm>
                </a-form-item>
                <a-form-item label="姓名" name="idcard_name" required>
                    <a-input placeholder="请输入" v-model:value="formState.idcard_name"></a-input>
                </a-form-item>
                <a-form-item label="手机号" name="phone" required>
                    <a-input placeholder="手机号码" @change="
                        (v) => {
                            phoneChange(v, 'phone')
                        }
                    " v-model:value="formState.phone"></a-input>
                </a-form-item>
                <a-form-item label="性别" name="sex">
                    <a-select style="width: 80px" v-model:value="formState.sex" placeholder="性别">
                        <a-select-option :value="1"> 男</a-select-option>
                        <a-select-option :value="2"> 女</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="民族" name="nation">
                    <a-select v-model:value="formState.nation" placeholder="民族">
                        <a-select-option :value="item" v-for="(item, index) in nationList" :Key="index"> {{ item
                        }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="身份证" name="idcard_num" required>
                    <a-input placeholder="身份证" v-model:value="formState.idcard_num"></a-input>
                </a-form-item>
                <a-form-item label="身份证地址" name="idcard_address">
                    <a-input placeholder="住所" v-model:value="formState.idcard_address"></a-input>
                </a-form-item>
                <a-form-item label="身份证有效期">
                    <a-row>
                        <a-col :span="10">
                            <a-form-item-rest>
                                <a-date-picker placeholder="身份证开始日期" :format="format"
                                    v-model:value="formState.starttime" />
                            </a-form-item-rest>
                        </a-col>
                        <a-col :span="10">
                            <a-form-item-rest>
                                <a-date-picker placeholder="身份证结束日期" :format="format" v-model:value="formState.endtime"
                                    style="width: 140px" class="mr-1x" :disabled="formState.identity_perpetual == 1" />
                            </a-form-item-rest>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item-rest>
                                <a-checkbox :checked="formState.identity_perpetual == 1 ? true : false"
                                    @change="identityPerpetualChange">长期</a-checkbox>
                            </a-form-item-rest>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD'
import { nationList } from '@/config/commonValues'
import IdCardForm from '../../logout/components/IdCardForm.vue'
const props = defineProps({
    userId: {
        type: Number,
        default: 0
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    loading: boolean
    free_money: string
    free_coupons: Array<any>
}
const state = reactive<state>({
    loading: false,
    free_money: '',
    free_coupons: []
})
interface formState {
    idcard_name: string
    phone: string
    sex: number
    nation: string
    idcard_num: string
    idcard_address: string
    id_card_front: string
    id_card_back: string
    // 身份证日期开始时间
    starttime: any
    // 身份证日期截止时间
    endtime: any
    identity_perpetual: number | null
}
let formState = reactive<formState>({
    idcard_name: '',
    phone: '',
    sex: 1,
    nation: '',
    idcard_num: '',
    idcard_address: '',
    id_card_front: '',
    id_card_back: '',
    // 身份证日期开始时间
    starttime: null,
    // 身份证日期截止时间
    endtime: null,
    identity_perpetual: 2
})
onMounted(() => {
    queryDetail(props.userId)
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: '/admin/v1/userInfo',
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            state.loading = false
            res.data.userinfo.starttime = dayjs(res.data.userinfo.starttime, format)
            res.data.userinfo.endtime = dayjs(res.data.userinfo.endtime, format)
            Object.assign(formState, res.data.userinfo)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                console.debug(res)
                message.error('操作失败')
            }
            state.loading = false
        })
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
}
const identityPerpetualChange = (val) => {
    formState.identity_perpetual = val.target.checked ? 1 : 2
    ruleForm.value.validateFields('endtime')
}
const frChange = (info) => {
    if (info.name) {
        formState.idcard_name = info.name
        formState.idcard_num = info.id_card_number
        formState.sex = info.gender
        formState.nation = info.nationality
        formState.idcard_address = info.address
        formState.starttime = info.id_card_validity_start
        formState.endtime = info.id_card_validity_end
        formState.identity_perpetual = info.identity_perpetual
    }
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            let requeryParam = {
                url: '/admin/v1/userShiming',
                method: 'post',
                data: formState
            }
            baseService(requeryParam)
                .then((res: any) => {
                    state.loading = false
                    message.success(res.msg)
                    emit('ok')
                })
                .catch((res) => {
                    state.loading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch(() => { })
}
const handleCancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
